<template>
	<v-dialog v-model="setdialog.dialog" max-width="1400" min-width="1400" style="min-height:537px;" persistent>
		<v-layout class="create_wrap display_inline_block" xs12>
			<!-- 헤더 시작-->
			<div class="project_title px-5" :style="`background-color:${$store.state.PointColor2}`">
				<!-- text -->
				<h2 style="font-size:15px">마케터 관리</h2>
				<v-spacer />
				<!-- icon -->
				<v-icon @click="setdialog.dialog = false" class="title-icon" color="white">mdi-close</v-icon>
			</div>
			<!-- 헤더 끝-->
			<v-layout column style=" background-color: #eee; padding: 20px;" wrap>
				<!-- 내부 전체 컨테이너 -->
				<v-layout px-5 py-4 wrap column style="border: 1px solid #d9d9d9; background-color: #fff">
					<!-- 내부 컨테이너-1 -->

					<v-layout wrap height="20%" width="100%">
						<v-flex xs12 my-2>
							<v-layout column>
								<v-layout align-center mb-5>
									<div class="slash mr-1"></div>
									<span class="title_font"> 기본정보 </span>
								</v-layout>
								<!-- 내부 셀 1줄 -->
								<v-layout class="mmd-row-default-container auto_height" align-stretch row justify-center>
									<v-flex class="mmd-row-default-inner-container" v-for="(i, key) in this.logDataArray()" :key="key">{{ i }}</v-flex>
								</v-layout>
							</v-layout>
						</v-flex>
					</v-layout>

					<!-- 내부 컨테이너-2 -->
					<v-layout wrap height="70%">
						<v-flex xs12 my-2>
							<v-layout row align-center>
								<!-- <v-layout justify-start align-center mb-2> -->
								<div class="slash mr-1"></div>
								<span class="title_font"> 처리현황 </span>
								<!-- </v-layout> -->
								<!-- 날짜 선택 --------- start -->
								<v-layout justify-start align-center>
									<v-flex :class="$vuetify.breakpoint.smAndDown ? 'my-2' : 'search_date_1'" class="ml-auto">
										<DatepickerDialog @input="dateSubmit" :picker="termStartpicker" :allowed_dates="maxStartDate"></DatepickerDialog>
									</v-flex>
									<span class="mx-1"> ~ </span>
									<v-flex :class="$vuetify.breakpoint.smAndDown ? 'my-2 ' : 'search_date_2'">
										<DatepickerDialog @input="dateSubmit" :picker="termEndpicker" :allowed_dates="maxEndDate"> </DatepickerDialog>
									</v-flex>
									<v-flex class="search_select mx-4" style="width:120px !important; max-width:120px !important;">
										<selectBox :sel="searchsel" @change="selectDays" :class="'searchSel'"></selectBox>
									</v-flex>
									<v-layout class="mmd-row-container" row>
										<v-flex xs2>
											배분 수량
										</v-flex>
										<v-flex xs2>
											{{ this.detail_data.distribution }}
										</v-flex>
										<v-flex xs2>
											처리
										</v-flex>
										<v-flex xs2>
											{{ this.detail_data.processed }}
										</v-flex>
										<v-flex xs2>
											미처리
										</v-flex>
										<v-flex xs2>
											{{ this.detail_data.unprocessesd }}
										</v-flex>
									</v-layout>
								</v-layout>
								<!-- 날짜 선택 --------- end -->
							</v-layout>
							<!-- --- 데이터 테이블 -------- start -->
							<v-layout class="mmd-table-container" wrap>
								<marketingDataTable :basedata="log_data">
									<template v-slot:tableHeaderWrap>
										<thead>
											<tr>
												<th rowspan="2" class="cell-base-bg" style="width: 11%;">
													접속이력
												</th>
												<th rowspan="2" class="cell-base-bg">
													배분수량
												</th>
												<th class="cell-darkBlue-bg" colspan="9">처리</th>
												<th class="cell-darkBlue-bg" rowspan="2">처리(계)</th>
												<th class="cell-gray-bg" rowspan="2">미처리</th>
											</tr>
											<tr class="cell-base-bg">
												<th>
													S
												</th>
												<th>
													A
												</th>
												<th>
													B
												</th>
												<th>
													C
												</th>
												<th>
													D
												</th>
												<th class="cell-blue-bg">
													성공(계/%)
												</th>
												<th class="cell-green-bg">
													예약
												</th>
												<th class="cell-orange-bg">
													보류
												</th>
												<th class="cell-darkRed-bg">
													거부
												</th>
											</tr>
										</thead>
									</template>
									<template v-slot:tableBodyWrap>
										<!-- 테이블 바디 -->
										<tbody v-if="log_data.items.length > 0">
											<!-- 로그 데이터 부분 -->
											<tr class="md-content-row" v-for="(item, itemIdx) of log_data.items" :key="`customTableBody-${itemIdx}`">
												<td v-for="(key, keyIdx) of log_data.headers" :key="`customTableKey-${keyIdx}`">
													<slot :name="`tableBody.${key.value}`" :item="item" :colIdx="keyIdx" :rowIdx="itemIdx">
														<span>{{ item[key.value] }}</span>
													</slot>
												</td>
											</tr>

											<!-- 합계 부분 -->
											<tr class="md-content-row-sum">
												<td v-for="(value, keyIdx) of sumArray" :key="`customTableKey-${keyIdx}`" :class="`${bgReturn(keyIdx)}`">
													<span>{{ value }}</span>
												</td>
											</tr>
										</tbody>
										<tbody v-else>
											<tr class="custom_table_empty">
												<td :colspan="log_data.headers.length">
													<span class="text-grey_other3">기간 내 접속 이력이 없습니다.</span>
												</td>
											</tr>
										</tbody>
									</template>
								</marketingDataTable>
							</v-layout>
							<!-- --- 데이터 테이블 -------- end -->
							<v-flex sm12 class="right_btn">
								<btn
									:btn="btn"
									:class="'small_action_btn'"
									:style="`background-color:${$store.state.PointColor2}`"
									:btn_txt="'마케터 삭제'"
									@click="marketerDelDialog()"
								></btn>
							</v-flex>
						</v-flex>
						<sweetAlert :dialog="sweetDialog" />
						<sweetAlert3 :dialog="deleteDialog" @click="marketerDel()" />
						<sweetAlert :dialog="successDialog" />
					</v-layout>
				</v-layout>
			</v-layout>
		</v-layout>
	</v-dialog>
</template>

<script>
import { btn, DatepickerDialog, selectBox, marketingDataTable, sweetAlert, sweetAlert3 } from '..'

export default {
	components: { btn, DatepickerDialog, selectBox, marketingDataTable, sweetAlert, sweetAlert3 },
	props: {
		setdialog: Object,
		detail_data: { type: Object, required: true },
		data_id: String,
	},

	methods: {
		async marketerDelDone() {
			await this.$parent.getTableData()
			this.setdialog.dialog = false
		},
		marketerDelDialog() {
			this.deleteDialog.title = `해당 상담사를 삭제합니다. <br/> 삭제된 상담사의 보유 DB는 자동 회수됩니다.`
			this.deleteDialog.buttonType = 'twoBtn'
			this.deleteDialog.open = true
		},
		async marketerDel() {
			this.deleteDialog.open = false

			let data = { counselorId: this.data_id, userId: String(this.$store.state.meData.id) }

			this.$store.state.loading = true
			await this.$store
				.dispatch('delCounselor', data)
				.then(res => {
					if (res.data.delCounselor.response.status === 1000) {
						this.sweetDialog.open = false
						this.setdialog.deleted = true
						this.successDialog.open = true
						this.successDialog.title = '삭제 완료'
						this.successDialog.content = '성공적으로 삭제 완료되었습니다.'
						this.successDialog.buttonType = 'oneBtn'
						this.successDialog.cancelBtnText = '확인'
						this.successDialog.closeFunction = this.marketerDelDone
					}
				})
				.catch(() => {
					this.sweetDialog.open = true
					this.sweetDialog.title = '삭제 오류'
					this.sweetDialog.content = '배정된 상담사가 없습니다.'
					this.sweetDialog.buttonType = 'oneBtn'
					this.sweetDialog.cancelBtnText = '확인'
				})

			this.$store.state.loading = false
			// this.sweetDialog.open = false
		},
		// 마케터 관리 로그 데이터 반환
		logDataArray() {
			const { glTitle, hqTitle, teamTitle, role } = this.detail_data
			const titles = [glTitle, hqTitle, teamTitle, role ? role.name : '']
			return [
				'이름',
				this.detail_data.name || '',
				'연락처',
				this.formatPhoneNumber(this.detail_data.phone) || '',
				'등록일',
				this.$moment(this.detail_data.created_at).format('YYYY-MM-DD HH:mm') || '',

				'소속/권한',
				titles.filter(Boolean).join('/'),
				'최근접속일',

				this.detail_data.recentLogin,
			]
		},
		storeLogData() {
			let arr = []
			for (let i = 0; i < this.logsArr.length; i++) {
				const {
					date,
					total_ditribution,
					grade_S,
					grade_A,
					grade_B,
					grade_C,
					grade_D,
					success,
					reserve,
					absence,
					reject,
					processed,
					unprocessed,
				} = this.logsArr[i] || {}

				let obj = {}

				obj = {
					date,
					total_ditribution,
					grade_S,
					grade_A,
					grade_B,
					grade_C,
					grade_D,
					success,
					reserve,
					absence,
					reject,
					processed,
					unprocessed,
				}
				arr.push(obj)
			}
			return arr
		},

		formatPhoneNumber(phone) {
			if (!phone) return ''
			return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
		},

		dateSubmit() {
			this.getLogData()
		},

		change() {},
		delete_chip(chips, chip_index) {
			chips.splice(chip_index, 1)
			this.delete_project()
		},

		/** Date 시작값과 끝나는 값에 해당하는 로그 데이터 불러오기
		@author 임호진
		*/
		async getLogData() {
			// 시작값이 끝나는 값보다 클시 error 표시 후 return
			if (this.termStartpicker.date > this.termEndpicker.date) {
				this.sweetDialog.title = '오류'
				this.sweetDialog.content = '시작값이 끝나는 시점보다 클수 없습니다!'
				this.sweetDialog.buttonType = 'oneBtn'
				this.sweetDialog.cancelBtnText = '확인'
				this.sweetDialog.open = true
				return
			}
			const data = {
				id: String(this.data_id),
				startDate: this.termStartpicker.date,
				endDate: this.termEndpicker.date,
			}
			await this.$store.dispatch('userLogs', data).then(res => {
				const { logs_data, summary } = res.data.userLogs.response ?? {}
				this.logsArr = logs_data
				this.summaryArr = summary
			})
			this.log_data.items = this.storeLogData()

			this.$store.state.loading = false
		},

		selectDays() {
			let date
			if (this.$moment().format('ddd') === 'Sun') {
				date = 6
			} else if (this.$moment().format('ddd') === 'Mon') {
				date = 0
			} else if (this.$moment().format('ddd') === 'Tue') {
				date = 1
			} else if (this.$moment().format('ddd') === 'Wed') {
				date = 2
			} else if (this.$moment().format('ddd') === 'Thu') {
				date = 3
			} else if (this.$moment().format('ddd') === 'Fri') {
				date = 4
			} else if (this.$moment().format('ddd') === 'Sat') {
				date = 5
			}
			if (this.searchsel.value === '오늘') {
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
				this.termStartpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.searchsel.value === '어제') {
				this.termStartpicker.date = this.$moment()
					.subtract(1, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.searchsel.value === '이번 주') {
				this.termStartpicker.date = this.$moment()
					.subtract(date, 'day')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.searchsel.value === '지난 주') {
				this.termStartpicker.date = this.$moment()
					.subtract(date + 7, 'day')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment()
					.subtract(date + 1, 'day')
					.format('YYYY-MM-DD')
			} else if (this.searchsel.value === '최근 7일') {
				this.termStartpicker.date = this.$moment()
					.subtract(7, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.searchsel.value === '최근 14일') {
				this.termStartpicker.date = this.$moment()
					.subtract(14, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.searchsel.value === '최근 30일') {
				this.termStartpicker.date = this.$moment()
					.subtract(30, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.searchsel.value === '이번 달') {
				this.termStartpicker.date = this.$moment()
					.subtract(Number(this.$moment().format('DD')) - 1, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.searchsel.value === '지난 달') {
				this.termStartpicker.date = this.$moment()
					.subtract(1, 'm')
					.startOf('month')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment()
					.subtract(1, 'm')
					.endOf('month')
					.format('YYYY-MM-DD')
			} else if (this.searchsel.value === '전체') {
				this.termStartpicker.date = ''
				this.termEndpicker.date = ''
			}
			this.getLogData()
		},

		bgReturn(index) {
			if (index === 7) {
				return 'cell-blue-bg'
			} else if (index === 8) {
				return 'cell-green-bg'
			} else if (index === 9) {
				return 'cell-orange-bg'
			} else if (index === 10) {
				return 'cell-darkRed-bg'
			} else if (index === 11) {
				return 'cell-darkBlue-bg'
			} else if (index === 12) {
				return 'cell-gray-bg'
			} else {
				return 'cell-white-bg'
			}
		},
		maxStartDate(val) {
			let endDate = this.$moment(this.termEndpicker.date).format('YYMMDD')
			val = this.$moment(val).format('YYMMDD') <= endDate
			return val
		},
		maxEndDate(val) {
			val = this.$moment(val).format('YYMMDD') <= this.$moment().format('YYMMDD')
			return val
		},
	},
	watch: {
		setdialog: {
			deep: true,
			handler() {
				if (this.setdialog.dialog === true) {
					// console.log('spread')
					this.$store.state.loading = true
					this.log_data.items = []
					this.selectDays()
				} else {
					this.searchsel.value = this.searchsel.items[1]
					// console.log('reset')
				}
			},
		},
		data_id: {
			handler() {
				if (this.data_id) {
					this.getLogData()
				}
			},
		},
		'this.successDialog.open': {
			handler() {
				if (this.successDialog.open === false) {
					this.setdialog.dialog.open = false
				}
			},
		},
	},

	computed: {
		// 마케터 관리 합계 데이터 반환
		sumArray() {
			const {
				total_ditribution,

				success,
				success_rate,
				reserve,
				reserve_rate,
				absence,
				absence_rate,
				reject,
				reject_rate,
				processed,
				processed_rate,
				unprocessed,
				unprocessed_rate,
				grade_S_total,
				grade_A_total,
				grade_B_total,
				grade_C_total,
				grade_D_total,
			} = this.summaryArr ?? {}

			return [
				'합계',
				total_ditribution,
				grade_S_total,
				grade_A_total,
				grade_B_total,
				grade_C_total,
				grade_D_total,
				`${success || '0'} / (${success_rate || '0'}%)` || '',
				`${reserve || '0'} / (${reserve_rate || '0'}%)` || '',
				`${absence || '0'} / (${absence_rate || '0'}%)` || '',
				`${reject || '0'} / (${reject_rate || '0'}%)` || '',
				`${processed || '0'} / (${processed_rate || '0'}%)` || '',
				`${unprocessed || '0'} / (${unprocessed_rate || '0'}%)` || '',
			]
		},
	},

	data: function() {
		return {
			sweetDialog: {
				open: false,
				title: '',
				content: '',
				cancelBtnText: '확인',
				modalIcon: 'info',
			},
			deleteDialog: {
				open: false,
				title: '',
				content: '',
				buttonType: 'twoBtn',
				modalIcon: 'warning',
				cancelBtnText: '취소',
				saveBtnText: '확인',
			},
			successDialog: {
				open: false,
				title: '',
				content: '',
				cancelBtnText: '확인',
				modalIcon: 'info',
			},
			logsArr: [],
			summaryArr: [],

			marketer_data: {},

			search_name: '',

			const_cell: ['이름', '연락처', '등록일', '소속/권한', '최근접속일'],

			variable_cell: ['임호진', '010-1234-5678', '2024-05-16 10:00', '1총괄/1본부/1팀/사원', '2024-05-16 10:00'],
			saveBtn: {
				color: '',
				dark: true,
				width: '82px',
				height: '26px',
			},
			select1: {
				placeholder: '1총괄',
				maxlength: '255',
				outlined: true,
				backCol: 'white',
				disabled: true,
			},
			log_data: {
				headers: [
					{ text: '접속이력', value: 'date', width: '10px' },
					{ text: '배분수량', value: 'total_ditribution', width: '9%' },
					{ text: 's', value: 'grade_S', width: '9%' },
					{ text: 'a', value: 'grade_A', width: '9%' },
					{ text: 'b', value: 'grade_B', width: '9%' },
					{ text: 'c', value: 'grade_C', width: '9%' },
					{ text: 'd', value: 'grade_D', width: '9%' },
					{ text: '성공', value: 'success', width: '9%' },
					{ text: '예약', value: 'reserve', width: '9%' },
					{ text: '보류', value: 'absence', width: '9%' },
					{ text: '거부', value: 'reject', width: '8%' },
					{ text: '처리', value: 'processed', width: '8%' },
					{ text: '미처리', value: 'unprocessed', width: '9%' },
				],
				// 로그데이터들
				items: [
					{
						date: '2024-05-17 10:22',
						total_ditribution: '100',
						grade_S: 10,
						grade_A: 10,
						grade_B: 10,
						grade_C: 10,
						grade_D: 10,
						success: 10,
						reserve: 1,
						absence: 3,
						reject: 2,
						processed: 4,
						unprocessed: 8,
					},
					{
						date: '2024-05-17 10:00',
						total_ditribution: '100',
						grade_S: 20,
						grade_A: 15,
						grade_B: 10,
						grade_C: 30,
						grade_D: 20,
						success: 10,
						reserve: 2,
						absence: 1,
						reject: 1,
						processed: 4,
						unprocessed: 8,
					},
				],
			},

			confirmBtn: {
				color: '',
				dark: true,
				width: '82px',
				height: '26px',
			},
			search_project: '',

			termStartpicker: {
				// datePicker

				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},

			termEndpicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},
			// 날짜/검색 데이터
			searchsel: {
				value: '이번 주',
				errorMessage: '',
				hideDetail: true,
				items: ['오늘', '이번 주', '이번 달'],
				outlined: true,
			},
			btn: {
				color: '',
				dark: true,
			},
		}
	},
}
</script>

<style lang="scss">
$cell-background: #eeeeee;

.create_wrap {
	background: #fff;
}
.project_title {
	background: #323153;
	color: #fff;

	display: flex;
	align-items: center;
}
.title_font {
	font-size: 15px;
	font-weight: bold;
}
.sub_text {
	border-left: 1px solid #d1d1d1;
}
.upload_box {
	margin: 0 auto !important;
}
.v-text-field__slot input {
	font-size: 12px;
	font-weight: normal;
}
.radioTime {
	.v-label {
		font-size: 0.75rem !important;
	}
}
.search_box {
	width: auto !important;
	height: 26px !important;
	margin-right: 8px !important;
	/* padding: 0 0 0 10px !important; */
	font-size: 13px;
	font-weight: bold;
	.v-btn__content {
		color: #fff;
	}
}

.md-content-row {
	td {
		border: 0.5px solid #c8c8c8 !important;
	}
}

.md-content-row-sum {
	position: sticky;
	bottom: 0;
	td {
		border: 0.5px solid #c8c8c8 !important;
	}
}

.mmd-table-container {
	text-align: center;
	th {
		text-align: center !important;
	}
}
.mmd-table-container .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
	height: 40px;
}

.mmd-table-container .v-data-table__wrapper {
	overflow: auto;
	max-height: 500px;
}
.mmd-table-container table {
	border-collapse: separate;
}
.mmd-table-container table thead {
	position: sticky;
	top: 0;
}
.mmd-row-default-inner-container {
	flex-wrap: wrap;
	height: auto !important;
}
.right_btn {
	text-align: right;
	margin-top: 12px;
}
</style>
